module.exports = "/_next/static/images/smsAuthen-46302e570aaefc7577c9f1c08b62779b.svg";